import { render, staticRenderFns } from "./DHL.vue?vue&type=template&id=531fd0e6&scoped=true"
import script from "./DHL.vue?vue&type=script&lang=js"
export * from "./DHL.vue?vue&type=script&lang=js"
import style0 from "./DHL.vue?vue&type=style&index=0&id=531fd0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531fd0e6",
  null
  
)

export default component.exports